export const getFinancialYearList = () => {
    const currentYear = new Date().getFullYear();

    // Build list: previous 2, current, next
    const years = [];
    for (let i = -1; i <= 0; i++) {
        const start = currentYear + i;
        const end = (start + 1).toString().slice(-2);
        years.push(`${start}-${end}`);
    }

    return years;
};


export const getFinancialYearListNew = (fy: string) => {
  if (!fy) return [];

  const startYear = parseInt(fy.split("-")[0]);

  const years = [];

  for (let i = -1; i <= 1; i++) {
    const start = startYear + i;
    const end = (start + 1).toString().slice(-2);
    years.push(`${start}-${end}`);
  }

  return years;
};